module.exports = __webpack_public_path__ + "static/media/roboto-100.66209ae0.ttf";